module.exports = __webpack_public_path__ + "img/nothing.3ac2b140.png";